<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label>{{ $t('page.generic.code') }} <required-field /></label>
                <b-form-input aria-describedby="codeField" :state="errors.some((e) => e.field === 'code')?false:null"
                              type="text" id="code" v-model="codingSchema.code" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label>{{ $t('page.generic.name') }} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="codingSchema.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{ $t('page.generic.description') }}</label>
                <b-form-textarea aria-describedby="description" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="codingSchema.description"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right ml-3" type="button" @click="createCodingSchema">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right ml-3" role="button"
                           :to="{name: 'documentTypeCodingSchemaRoute'}">
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '@/components/PageTitle'
  import CodingSchemaService from "@/services/CodingSchemaService"
  import RequiredField from "../../components/RequiredField";

  const codingSchemaService = CodingSchemaService.build();

  export default {
    name: 'codingSchemaNew',
    inheritAttrs: false,
    components: {
      RequiredField,
      PageTitle
    },
    data() {
      return {
        codingSchema: {},
        errors: [],
      }
    },
    created() {
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    },
    methods: {
      async createCodingSchema() {
        try {
          let newCodingSchema = await codingSchemaService.create(this.codingSchema);
          this.$router.push({name: 'documentTypeCodingSchemaShowRoute', params: {id: newCodingSchema.id}});
          miniToastr.info("Coding Schema creato con successo");
        } catch (exception) {
          if (exception.errors) {
            this.errors = exception.errors;
            exception.errors.forEach(function (element) {
              miniToastr.error(element.message);
            });
          } else {
            miniToastr.error(exception.message);
          }
        }
      },
    }
  }
</script>

